/**
 * Universal form styles for TextField, Autocomplete and other form components
 */
import { SxProps, Theme } from '@mui/material';

export interface FormFieldStylesProps {
    error?: boolean;
    marginTop?: number;
}

/**
 * Styles for TextField component
 */
export const getTextFieldStyles = (props: FormFieldStylesProps = {}): SxProps<Theme> => ({
    marginTop: props.marginTop ?? 0,
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: props.error ? "error.main" : "#474747ff",
        },
        "&:hover fieldset": {
            borderColor: props.error ? "error.main" : "rgba(255, 255, 255, 0.5)",
        },
        "&.Mui-focused fieldset": {
            borderColor: props.error ? "error.main" : "primary.main",
        },
    },
    "& .MuiInputLabel-root": {
        color: "text.secondary",
        "&.Mui-focused": {
            color: "primary.main",
        },
        // Removed required asterisk (*)
    },
    "& .MuiInputBase-input": {
        color: "text.primary",
    },
    "& .MuiAutocomplete-input": {
        color: "text.primary",
    },
    "& .MuiAutocomplete-endAdornment": {
        "& .MuiSvgIcon-root": {
            color: "text.secondary",
        },
    },
});

/**
 * Styles for Autocomplete component (popper/dropdown)
 */
export const getAutocompleteStyles = (): SxProps<Theme> => ({
    width: '100%',
    '& .MuiAutocomplete-popper': {
        '& .MuiPaper-root': {
            backgroundColor: '#1e1e1e',
            color: 'white',
        },
        '& .MuiAutocomplete-listbox': {
            backgroundColor: '#1e1e1e',
            '& .MuiAutocomplete-option': {
                color: 'white',
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
                '&.Mui-focused': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
            },
        },
    },
});

/**
 * Styles for Autocomplete ListboxProps
 */
export const getAutocompleteListboxStyles = (): SxProps<Theme> => ({
    backgroundColor: '#1e1e1e',
    color: 'white',
    '& .MuiAutocomplete-option': {
        color: 'white',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        '&.Mui-focused': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
});
